import axios from "axios";
import { apiCheckLogin, apiDangKy, apiDangNhap, apiVpos, apiRegisterByEmail, apiSearchBank, apiUploadImg, 
  apiComfrimPhoneOTP, apiChangePassPhone,apiComfrimChangePassPhone, apiCategory} from "./api";

import CryptoJS from "crypto-js";


export const getMD5 = (input) => {
  return CryptoJS.MD5(input).toString();
};
const header = {
  "Access-Control-Allow-Origin": "https://vimass.vn",
  "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
  "Access-Control-Allow-Headers":
    "DNT,X-Mx-ReqToken,Keep-Alive,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range",
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Max-Age": 3600,
  "Access-Control-Expose-Headers": "Content-Length",
};
const codeCheckSum = "0819226669jdqpowrifioefiqo3289r79f";
const currentTime = new Date().getTime();
const userLapTrinh = "0979951954";
//keyStote
export const KEY_SESSION_ID = sessionStorage.getItem("sessionUser");
export const KEY_PHONE_ID = sessionStorage.getItem("phoneUser");
export const KEY_TYGIA = localStorage.getItem("objTyGia");
export const KEY_CHONTYGIA = localStorage.getItem("chonTyGia");
export const KEY_ID_STORE = localStorage.getItem("idCuaHang") ;

//check login
export const getCheckLoginUser = (idVi) => {
  var cks = getMD5(currentTime + "1216546" + idVi + userLapTrinh);
  return axios
    .get(
      apiCheckLogin + currentTime + "_" + cks + "_" + idVi + "_" + userLapTrinh,
      {
        headers: header,
      }
    )
    .then((res) => {
      return res.data;
    });
};
//  dang nhap
export const postLogin = (
  user,
  pass,
  deviceId,
  VimassMH,
  companyCode,
  type
) => {
  return axios
    .post(
      apiDangNhap,
      { user, pass, deviceId, VimassMH, companyCode, type },
      {
        headers: header,
      }
    )
    .then((res) => {
      return res.data;
    });
};
//  dang ky
export const postResgister = (phone, pass) => {
  var funcId = 21;
  var deviceId = 4;
  var appId = 1;
  return axios
    .post(
      apiDangKy,
      { phone, pass, appId, deviceId, funcId },
      {
        headers: header,
      }
    )
    .then((res) => {
      return res.data;
    });
};
//postLayDsStore
export const postLayDsStore = (sessionLogin, idLogin, accOwner) => {
  var funcId = 2;
  var timeRequest = currentTime;
  var companyCode = "";
  var typeLogin = 0;
  var idStore = "";
  var mcId = "";
  var limit = 20;
  var offset = 0;

  var cksInput = getMD5(
    codeCheckSum +
      sessionLogin +
      idLogin +
      typeLogin +
      idStore +
      timeRequest +
      limit +
      offset
  );

  return axios
    .post(
      apiVpos,
      {
        funcId,
        sessionLogin,
        idLogin,
        typeLogin,
        accOwner,
        companyCode,
        idStore,
        mcId,
        timeRequest,
        cksInput,
        limit,
        offset,
      },
      {
        headers: header,
      }
    )
    .then((res) => {
      return res.data;
    });
};
//searchBank

export const postSearchBank = (
  user,
  session,
  soTaiKhoan,
  maNganHang,
  soThe
) => {
  var appId = 5;
  var VMApp = 4;
  var VimassMH = 1;
 
  return axios
    .post(
      apiSearchBank,
      { user, session, soTaiKhoan, maNganHang, soThe, appId, VMApp, VimassMH },
      {
        headers: header,
      }
    )
    .then((res) => {
      return res.data;
    });
};

export const postImage = (value ,idCheck )=>{
var data = {
  value: value,
  idCheck: idCheck,
}
return axios.post(apiUploadImg, data, {headers:header}) .then((res) => {
  return res.data;
});
}
// tao san pham
export const postProduct = (sessionLogin,idLogin,token,gia,giaGiam,idStore,idCate,productName,image,thumbnail,description) =>{
  var companyCode = "";
  var typeLogin = 0;
  var timeRequest = currentTime;
  var productNameBoDau = productName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
var data = {
  funcId:40,
  sessionLogin:sessionLogin,
  idLogin:idLogin,
  token:token,
  typeLogin:typeLogin,
  companyCode:companyCode,
  timeRequest:timeRequest,
  gia:gia,
  giaGiam:giaGiam,
  idStore:idStore,
  idCate:idCate,
  productName:productName,
  image:image,
  thumbnail:thumbnail,
  description:description,
  cksInput:getMD5("0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + idLogin + typeLogin + timeRequest + idStore +idCate + image + productNameBoDau + image + thumbnail + gia + giaGiam)
 
};
console.log("0819226669jdqpowrifioefiqo3289r79f" +" "+ sessionLogin +" "+  idLogin +" "+  typeLogin +" "+  timeRequest +" "+  idStore +" "+ idCate +" "+  image +" "+ productNameBoDau +" "+  image +" "+ thumbnail +" "+ gia+" "+ giaGiam);
return axios
.post(apiVpos , data,
  {
    headers: header,
  }
)
.then((res) => {
  return res.data;
});

}
//tao cửa hàng
export const postCreatesStore = (
  sessionLogin,
  idLogin,
  token,
  storeName,
  storeAdd,
  storeCode,
  idParent,
  totalLimitlogo,
  typeWithDrawMoney,
  numberOfTransactions,
  totalTables,
  image,
  emailLH,
  sdtLH,
  bankCode,
  bankNumber,
  lat,
  lng,
  rShowName,
  rMarName,
  rShow,
  rMar
) => {
  var companyCode = "";
  var typeLogin = 0;
  var mcId = "";
  var timeRequest = currentTime;
  var logo ="";
  const storeNameWithoutDiacritics = storeAdd.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "");
  console.log(storeNameWithoutDiacritics);
  var data = {
    funcId: 1,
    sessionLogin: sessionLogin,
    idLogin: idLogin,
    token: token,
    typeLogin: typeLogin,
    companyCode: companyCode,
    storeName: storeName,
    storeAdd: storeNameWithoutDiacritics,
    storeCode: storeCode,
    idParent: idParent,
    totalLimitlogo: totalLimitlogo,
    typeWithDrawMoney: typeWithDrawMoney,
    numberOfTransactions: numberOfTransactions,
    totalTables: totalTables,
    logo: logo,
    image: image,
    emailLH: emailLH,
    sdtLH: sdtLH,
    bankCode: bankCode,
    bankNumber: bankNumber,
    lat: lat,
    lng: lng,
    rShowName: rShowName,
    rMarName: rMarName,
    rShow: rShow,
    rMar: rMar,
    mcId: mcId,
    timeRequest: timeRequest,
    cksInput: getMD5(
      "0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + idLogin + typeLogin + companyCode + idParent
      + timeRequest + storeNameWithoutDiacritics + storeCode + logo + image + emailLH + sdtLH + bankCode + bankNumber
      + mcId + rMar + rShow)
  };
console.log("log input ", data);
  return axios
    .post(
      // apiVpos, {data.funcId, data.sessionLogin ,data.idLogin,data.token,data.typeLogin,data.companyCode,data.storeName,data.storeAdd,data.storeCode,data.idParent,data.totalLimitlogo,data.typeWithDrawMoney,
      // data.numberOfTransactions,data.totalTables,data.logo,data.image, data.emailLH,data.bankCode,data.bankNumber,data.lat, data.lng, data.rShowName, data.rMarName, data.mcId, data.timeRequest, data.cksInput}
    apiVpos , data,
      {
        headers: header,
      }
    )
    .then((res) => {
      return res.data;
    });
};



//  dang ky email
export const postResgisterByEmail = (email, pass , ipWan) => {
  var funcId = 190;
  var ip = ipWan;
  var timeRequest = currentTime;
  var userLTV = "0981455707";
  var VMApp = 4;
  var deviceId = 2;
  var passL = btoa(pass);

  var keyTheoVMApp = "Y4SkpSofFAgsR27fMBM02SNoV9iPI2CBo0ZCImM6EgnfXikl3en3VfWyTwfLLTC883yJC";
  var cksInput = getMD5(keyTheoVMApp + userLTV + email + timeRequest + ip + deviceId + passL);

  var data = {funcId,ip,timeRequest,userLTV,VMApp,deviceId,email,passL,cksInput};
  console.error('postResgisterByEmail =========>'+JSON.stringify(data));
  return axios
    .post(apiRegisterByEmail, data,
    {
      headers: header,
    })
    .then((res) => {
      return res.data;
    });
};

export const getIpWan = () => {
  return axios
    .get('https://api.ipify.org?format=json')
    .then((res) => {
      return res.data.ip; 
    })
    .catch((error) => {
      console.error('Error fetching IP address:', error);
      return null;
    });
};

//  comfrim code OTP 
export const postComfrimOTP = (codeOTP, ipWan, ConfirmOTP) => {
  var funcId = 191;
  var ip = ipWan;
  var timeRequest = currentTime;
  var userLTV = "0981455707";
  var VMApp = 4;
  var deviceId = 2;
  var idConfirm = codeOTP;
  var otpConfirm = ConfirmOTP;
  var keyTheoVMApp = "Y4SkpSofFAgsR27fMBM02SNoV9iPI2CBo0ZCImM6EgnfXikl3en3VfWyTwfLLTC883yJC";
  var cksInput = getMD5(keyTheoVMApp + userLTV + idConfirm + timeRequest + ip + deviceId + otpConfirm);

  var data = {funcId,ip,timeRequest,userLTV,VMApp,deviceId,idConfirm,otpConfirm,cksInput};
  console.error('postComfrimOTP =========>'+JSON.stringify(data));
  return axios
    .post(apiRegisterByEmail, data,
    {
      headers: header,
    })
    .then((res) => {
      return res.data;
    });
};

//  login by email
export const postLoginByEmail = (emailInput, ipWan, pass) => {
  var funcId = 192;
  var ip = ipWan;
  var timeRequest = currentTime;
  var userLTV = "0981455707";
  var VMApp = 4;
  var deviceId = 2;
  var email = emailInput;
  var passLogin = pass;
  var keyTheoVMApp = "Y4SkpSofFAgsR27fMBM02SNoV9iPI2CBo0ZCImM6EgnfXikl3en3VfWyTwfLLTC883yJC";
  var cksPassLogin = getMD5(keyTheoVMApp + passLogin + timeRequest);
  var cksInput = getMD5(keyTheoVMApp + userLTV + email + timeRequest + ip + deviceId + cksPassLogin);
  
  var data = {funcId,ip,timeRequest,userLTV,VMApp,deviceId,email,cksPassLogin,cksInput};
  console.error('postComfrimOTP =========>'+JSON.stringify(data));
  return axios
    .post(apiRegisterByEmail, data,
    {
      headers: header,
    })
    .then((res) => {
      return res.data;
    });
};


export const convertToBase64 = (thumbnail) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function() {
      const reader = new FileReader();
      reader.onloadend = function() {
        resolve(reader.result.split(',')[1]);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.onerror = reject;
    xhr.open('GET', thumbnail);
    xhr.responseType = 'blob';
    xhr.send();
  });
}

//  comfrim code OTP 
export const postComfrimPhoneOTP = (phoneComfrim, phoneOTP) => {
  var funcId = 64;
  var phone = phoneComfrim;
  var otp = phoneOTP;
  

  var data = {funcId,phone,otp};
  console.error('postComfrimOTP =========>'+JSON.stringify(data));
  return axios
    .post(apiComfrimPhoneOTP, data,{
      headers: header,
    }).then((res) => {
      return res.data;
    });
};


//  change pass phone
export const getChnagePassPhone = (phoneComfrim, phoneOTP) => {
  var phone = phoneComfrim;
  var par = phoneOTP;
  const url = apiChangePassPhone+"?phone="+phone+"&par="+par;
 // console.log("url ======> " +url);
  return axios
    .get(url ,{
        headers: header,
      }).then((res) => {
      return res.data;
    });
};

//  comfrim change pass phone
export const comfrimGetChnagePassPhone = (phoneChange, codeOTP, parNew) => {
  var phone = phoneChange;
  var otp = codeOTP;
  var par = parNew;
  const url = apiComfrimChangePassPhone+"?phone="+phone+"&otp="+otp+"&par="+par;
  console.log("url ======> " +url);
  return axios
    .get(url ,{
        headers: header,
      }).then((res) => {
      return res.data;
    });
};
// Tạo thông tin 1 category
export const postCreateCategory = (inputToken, InputIdStore, inputCateName) => {
  var funcId = 20;
  var sessionLogin = KEY_SESSION_ID;
	var idLogin = KEY_PHONE_ID;
	var token = inputToken;
	var typeLogin = 0; //0 - vis sdt/email; 1- the da nang; 2 la vi doanh nghiep
	var companyCode =""; // dang vang vi doanh nghiep thi moi truyen
	var idStore = InputIdStore;
	var catName = inputCateName;
	var image = "";
	var timeRequest = new Date().getTime();
	var description = "";

  var cksInput = getMD5("0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + idLogin + typeLogin + timeRequest + idStore + image + removeVietnameseDiacritics(catName));
  
  var data = {funcId,sessionLogin,idLogin,token,typeLogin,companyCode,idStore,catName,image,timeRequest,description,cksInput };
  console.error('postCreateCategory =========>'+JSON.stringify(data));
  return axios
    .post(apiCategory, data,{
      headers: header,
    }).then((res) => {
      return res.data;
    });
};

export const removeVietnameseDiacritics = (str) =>{

  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const postReceiveListCategory = (inputIdStore, inputOffset ,inputLimit) => {
  console.log('postReceiveListCategory =========> nhay vao day');
  var funcId = 22;
  var sessionLogin = KEY_SESSION_ID;
	var idLogin = KEY_PHONE_ID;
	var typeLogin = 0; //0 - vis sdt/email; 1- the da nang; 2 la vi doanh nghiep
	var companyCode =""; // dang vang vi doanh nghiep thi moi truyen
	var idStore = inputIdStore;
	var timeRequest = new Date().getTime();
  var offset = inputOffset;
  var limit = inputLimit;

  var cksInput = getMD5("0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + idLogin + typeLogin + timeRequest + idStore + offset + limit);
  var data = {funcId,sessionLogin,idLogin,typeLogin,companyCode,idStore,timeRequest,offset,limit,cksInput};

   console.log('postReceiveListCategory =========>'+JSON.stringify(data));
   return axios
   .post(apiCategory, data,{
     headers: header,
   }).then((res) => {
     return res.data;
   });
};

export const postEditCategory = (inputToken, inputIdStore, inputIdCat ,inputCatName, status) => {
  console.log('postReceiveListCategory =========> nhay vao day');
  var funcId = 21;
  var sessionLogin = KEY_SESSION_ID;
	var idLogin = KEY_PHONE_ID;
  var token = inputToken;
	var typeLogin = 0; //0 - vis sdt/email; 1- the da nang; 2 la vi doanh nghiep
	var companyCode =""; // dang vang vi doanh nghiep thi moi truyen
	var idCat = inputIdCat; 
	var idStore = inputIdStore;
	var catName = inputCatName;
	
	var image = "";
	var timeRequest = new Date().getTime();
	var description = "";

	var trangThai = status;

  var cksInput = getMD5("0819226669jdqpowrifioefiqo3289r79f" + sessionLogin + idLogin + typeLogin + timeRequest + idStore + image + removeVietnameseDiacritics(catName) + idCat + trangThai);
  var data = {funcId,sessionLogin,idLogin,token,typeLogin,companyCode,idCat,idStore,catName,image,timeRequest,description,trangThai,cksInput};

   console.log('postEditCategory =========>'+JSON.stringify(data));
   return axios
   .post(apiCategory, data,{
     headers: header,
   }).then((res) => {
     return res.data;
   });
};


